import type { VisualizationProps } from './types';

/**
 * KitchenSVG — порт из `docs/prototypes/screen-2.6.2-configurator.html`
 * lines 122-176. Прототип — единственный source of truth UI Block 6.
 *
 * Зоны: facade, corpus, handles, countertop. Hooks НЕ отображается
 * (прототип не показывает; крючки на кухне визуально малозначимы).
 * Декоративные детали (варочная, мойка) — фиксированные цвета.
 * Конвенции — `./types.ts`.
 */
export function KitchenSVG({
  facadeColor,
  countertopColor,
  corpusColor,
  handlesColor,
}: VisualizationProps) {
  return (
    <svg
      viewBox="0 0 320 200"
      width="100%"
      height="auto"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="0" y="0" width="320" height="200" fill="#f9f6f2" />
      <rect x="0" y="185" width="320" height="15" fill="#d8cfc4" />

      {/* Верхние шкафы (corpus) */}
      <rect
        data-testid="zone-corpus"
        x="10"
        y="10"
        width="80"
        height="60"
        fill={corpusColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        x="95"
        y="10"
        width="80"
        height="60"
        fill={corpusColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        x="180"
        y="10"
        width="80"
        height="60"
        fill={corpusColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        x="265"
        y="10"
        width="45"
        height="60"
        fill={corpusColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />

      {/* Столешница */}
      <rect
        data-testid="zone-countertop"
        x="10"
        y="112"
        width="300"
        height="12"
        fill={countertopColor}
        stroke="#000000"
        strokeWidth="1"
      />

      {/* Нижние фасады */}
      <rect
        data-testid="zone-facade"
        x="10"
        y="125"
        width="70"
        height="58"
        fill={facadeColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        x="84"
        y="125"
        width="70"
        height="58"
        fill={facadeColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        x="158"
        y="125"
        width="70"
        height="58"
        fill={facadeColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        x="232"
        y="125"
        width="78"
        height="58"
        fill={facadeColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />

      {/* Ручки */}
      <rect
        data-testid="zone-handles"
        x="41"
        y="128"
        width="8"
        height="2"
        fill={handlesColor}
        rx="1"
      />
      <rect x="115" y="128" width="8" height="2" fill={handlesColor} rx="1" />
      <rect x="189" y="128" width="8" height="2" fill={handlesColor} rx="1" />
      <rect x="263" y="128" width="8" height="2" fill={handlesColor} rx="1" />

      {/* Варочная (decorative) */}
      <rect
        x="100"
        y="96"
        width="80"
        height="14"
        fill="#888"
        stroke="#555"
        strokeWidth="0.5"
        rx="3"
      />
      <circle cx="115" cy="103" r="4" fill="#666" />
      <circle cx="130" cy="103" r="4" fill="#666" />
      <circle cx="155" cy="103" r="4" fill="#666" />
      <circle cx="170" cy="103" r="4" fill="#666" />

      {/* Мойка (decorative) */}
      <rect
        x="215"
        y="96"
        width="60"
        height="14"
        fill="#c8c8c8"
        stroke="#888"
        strokeWidth="0.5"
        rx="2"
      />
      <rect x="220" y="98" width="52" height="10" fill="#b0b0b0" rx="1" />

      {/* Номера зон */}
      <text
        x="46"
        y="158"
        textAnchor="middle"
        fontSize="9"
        fill="#000000"
        fontWeight="600"
        fontFamily='"Manrope Variable", sans-serif'
      >
        1
      </text>
      <text
        x="120"
        y="158"
        textAnchor="middle"
        fontSize="9"
        fill="#000000"
        fontWeight="600"
        fontFamily='"Manrope Variable", sans-serif'
      >
        1
      </text>
      <text
        x="163"
        y="43"
        textAnchor="middle"
        fontSize="8"
        fill="#000000"
        fontWeight="600"
        fontFamily='"Manrope Variable", sans-serif'
      >
        2
      </text>
      <text
        x="160"
        y="120"
        textAnchor="middle"
        fontSize="8"
        fill="#000000"
        fontWeight="600"
        fontFamily='"Manrope Variable", sans-serif'
      >
        3
      </text>
    </svg>
  );
}
